import * as Yup from 'yup'
import { getInitialState } from '../../../utils/formikUpdate'
import { fetchAllCantones } from '../../../services/cantonService'
import { fetchAllTenants } from '../../../services/tenantService'

export const datasetFormik = async () => {
  // Obtener cantones y tenants para los selects
  let cantonesOptions = {}
  let tenantsOptions = {}

  try {
    const [cantones, tenants] = await Promise.all([
      fetchAllCantones(),
      fetchAllTenants(),
    ])

    cantones.forEach(c => {
      cantonesOptions[c.id] = c.name || c.nombre
    })

    tenants.forEach(t => {
      tenantsOptions[t.id] = t.fullName || t.nombre_completo || t.name || t.nombre
    })
  } catch (err) {
    console.error('Error loading data:', err)
  }

  const ITEMS_RELATION_FORMIK = [
    {
      x: 6,
      name: 'id_canton',
      initvalue: '',
      label: 'Cantón',
      options: cantonesOptions,
    },
    {
      x: 6,
      name: 'id_tenant',
      initvalue: '',
      label: 'Tenant',
      options: tenantsOptions,
    },
    {
      x: 4,
      name: 'orden',
      initvalue: 1,
      label: 'Orden',
      type: 'number',
    },
    {
      x: 4,
      name: 'es_principal',
      initvalue: 0,
      label: 'Principal',
      options: { 0: 'No', 1: 'Sí' },
    },
    {
      x: 4,
      name: 'habilitado',
      initvalue: 1,
      label: 'Estado',
      options: { 0: 'Desactivado', 1: 'Activado' },
    },
  ]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_RELATION_FORMIK)

  const FORM_VALIDATION = Yup.object().shape({
    id_canton: Yup.number()
      .required('Obligatorio')
      .typeError('Seleccione un cantón'),
    id_tenant: Yup.number()
      .required('Obligatorio')
      .typeError('Seleccione un tenant'),
    orden: Yup.number()
      .min(0, 'Orden mínimo 0')
      .required('Obligatorio')
      .typeError('Debe ser un número'),
  })

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_RELATION_FORMIK,
    FORM_VALIDATION,
  }
}
